'use client'

import { Suspense, useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { sanity } from '../services/sanity/client'
import { pageQuery, templateSelector } from '../services/sanity/queries/pages'
import { SanityPage } from '../services/sanity/types'
import type { Building } from '../types/building'

const ClientPage = dynamic(() => import('./[[...slug]]/client-page').then((mod) => ({ default: mod.ClientPage })), {
  ssr: false,
  loading: () => null,
})

export function NotFoundClient({ buildings }: { buildings: Building[] }) {
  const [payload, setPayload] = useState<SanityPage<unknown> | null>(null)
  const [loading, setLoading] = useState(true)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)

    const fetchData = async () => {
      try {
        const data = await sanity.fetch<SanityPage<unknown> | null>(
          pageQuery('/not-found', templateSelector('tmFlexible'))
        )
        document.title = data?.title || 'Not Found - YourStudio'
        setPayload(data)
      } catch (error) {
        console.error('Error fetching not-found page:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  if (!mounted || loading) {
    return null
  }

  if (payload) {
    return (
      <Suspense>
        <ClientPage payload={payload} buildings={buildings} />
      </Suspense>
    )
  }

  return (
    <div className="flex h-screen items-center justify-center">
      <h1 className="text-4xl font-bold">404 - Not found</h1>
    </div>
  )
}
